import { Component, Input } from '@angular/core';
import { Instance } from '../../../base/entities/transport.interface';
import { TranslateModule } from '@ngx-translate/core';
import { ZenithComponentsModule } from '@mateco/zenith-webcomponents-angular/dist/zenith-webcomponents-angular';


@Component({
  selector: 'app-instance-location',
  standalone: true,
  imports: [TranslateModule, ZenithComponentsModule],
  templateUrl: './instance-location.component.html',
})
export class InstanceLocationComponent {

  @Input() instance: Instance;

}
